export const PAGE_TITLE = '城市选择'

export const URL_CMS_GET_APP_CONFIG = 'https://cms.cekid.com/publish/890/appset_service2021.json'

export const URL_CMS_GET_CITY_LIST = 'https://cms.cekid.com/publish/890/cityList.json'